module.exports = __webpack_public_path__ + "static/social-lebc-cover-3674f009d8fb01b4a84bc7dd68fcf6e1.png";